import domReady from '@wordpress/dom-ready';

domReady(() => {
  const alertBanner = document.querySelector('.alert-banner');
  if (!alertBanner) return;

  const alertId = alertBanner.dataset.alertId;
  const body = document.body;

  // Check if the alert has already been dismissed
  const dismissedAlertId = localStorage.getItem('dismissedAlertId');
  if (dismissedAlertId === alertId) {
    alertBanner.remove();
    body.classList.remove('alert-bar');
    return;
  }

  // Add click event to close the alert
  const closeIcon = alertBanner.querySelector('.icon-close');
  if (closeIcon) {
    closeIcon.addEventListener('click', function () {
      alertBanner.remove();
      body.classList.remove('alert-bar');
      localStorage.setItem('dismissedAlertId', alertId);
    });
  }
});
